<style lang="less" scoped>
    ul li{
        list-style: none;
    }
    .clear{
        clear: both;
    }
    .cont{
        height: 200px;
        background: #fff;
        padding: 20px;
        .studentNum,.groupNum{
            width: 600px;
            height: 30px;
            line-height: 30px;
            margin-top: 0px;
        }
        .groupNum{
            margin-top: 20px;
        }
        .main{
            margin-top: 0px;
        }
        .begin{
            width: 120px;
            height: 30px;
            background: @primary-color;
            color:#fff;
            margin-left: 100px;
        }
        .refresh{
            display: inline-block;
            width: 80px;
            margin-left: 20px;
            color:#a3af90;
            cursor: pointer;
        }
    }
    .newGroupInfo{
        margin-top: 20px;
        .groupMess{
            min-height: 120px;
            background: #fff;
            margin-top: 20px;
            padding:0px 20px 20px 20px;
            .groupTitle{
                height:40px;
                line-height: 40px;
                font-size: 20px;
                color:#040506;
                .edit{
                    color: @primary-color;
                    cursor: pointer;
                    margin-left: 10px;
                    width: 25px;
                    height: 25px;
                }
                /deep/.ant-input, .ant-input-disabled{
                    background: #fff;
                    font-size: 20px;
                    color: #040506;
                    width: 220px;
                }
            }
            ul{
                margin: 0px;
                padding: 0px;
                min-height: 120px;
                li{
                    width: 33%;
                    height:45px;
                    line-height:45px;
                    float: left;
                    .userImg{
                        width: 40px;
                        height: 40px;
                        border-radius: 50%;
                    }
                    .userName{
                        color: #000;
                        font-size: 20px;
                        margin-left: 12px;
                    }
                    /deep/.ant-btn{
                        width: 60px;
                        height: 25px;
                        line-height: 25px;
                        border: 1px solid @primary-color;
                        margin-left: 5px;
                        color: @primary-color;
                    }
                }
            }
        }
        .saveMess{
            text-align: center;
            height: 50px;
            line-height: 50px;
        }
        /deep/.ant-layout-content>div{
            padding: 0px;
        }
    }
</style>
<template>
<div style="background:#f6f6f6;">
    <div class="cont">
        <a-row class="studentNum">
            <a-col :span="4">班级总人数</a-col>
            <a-col :span="18"> <a-input :disabled="disableNum==false" v-model="stuNum"/></a-col>
            <a-col style="text-align:center;" :span="2">人</a-col>
        </a-row>
        <a-row class="groupNum">
            <a-col :span="4">小组数量</a-col>
            <a-col :span="18">
                <a-input v-model="groupNum" />
            </a-col>
            <a-col style="text-align:center;" :span="2">组</a-col>
        </a-row>
        <div class="groupNum">
            <a-button class="begin" @click="randomGroup">开始生成小组</a-button>
            <!-- <span group="refresh"><a-icon type="sync" /> &nbsp;&nbsp;刷新</span> -->
        </div>
    </div>
    <div class="newGroupInfo">
        <div class="groupMess" v-for="(item,index) in groups" :key="index+item.id">
            <div class="groupTitle">
                <a-input  type="text" ref="input" v-model="item.groupName" :disabled='editGroup'  @blur="editGroupNameChange(item)" />
                <span class="editGroupName" @click="editGroupName(index,item.id)">
                    <a-icon type="edit" class="edit" />
                </span>
            </div>
            <ul>
                <li v-for="(s,index) in item.students" :key="index+'stu'">
                    <img class="userImg" v-if="s.photo&&s.photo!=null" :src="resbaseUrl+'/'+s.photo" alt="" />
                    <img class="userImg" v-else src="imgs/stu-photo.png" alt="" />
                    <span class="userName">{{s.userName}}</span>
                    <a-button v-if="s.isGroupLeader==1">组长</a-button>
                </li>
            </ul>
        </div>
        <div class="saveMess">
            <a-button type="primary" @click="saveGroup">保存小组</a-button>
        </div>
    </div>
</div>
</template>

<script>
import shareState from '../../utils/shareState.js'
export default {
    name: 'RandomGroup',
    data(){
        return{
            resbaseUrl: this.$userINfoBasePath+ '/' ,
            shareData: shareState.state,
            stuNum: '', //学生数量
            groupNum: '1', //分组的数目
            classId: '', //班级ID
            groupid: '',//路由传过来的参数
            groups: [], //分组后的小组列表
            groupUuid: '', //随机生成组标识
            editGroup: true,
            disableNum: false,
            mrImg: require('../../assets/imgs/student.png'),
            limitFlag: false,
            paramGroup: []
        }
    },
    watch:{
        $route () {
            this.groupid = this.$route.params.groupid
        }
    },
    beforeMount (){

    },
    mounted (){
        this.getClassInfo()
    },
    methods: {
        randomGroup () { //随机生成的小组
            const param = {
                classId: localStorage.getItem('classID'),
                count: this.groupNum || 1
            }
            let _this = this
            _this.$fetch({
                url: _this.$baseUrl + 'ebook/class/common/classRandomGroup',
                body:param
            }).done( res => {
                if(res && res.success && res.resultCode === 0){
                    //this.$message.success('分组成功')
                    _this.groups = res.resultData.groups
                    _this.groupUuid = res.resultData.groupUuid
                }else{
                    _this.$message.warning(res.resultMessage)
                }
            })
        },
        //ebook/group/common/saveClassRandomGroup
        saveGroup () { // 保存随机生成的小组
            this.limitFlag = false
            this.groups.forEach(item => {
                if(item.groupName.length>8){
                    this.limitFlag = true
                }else{
                    this.paramGroup.push({
                        id: item.id,
                        groupName: item.groupName
                    })
                }
            })
            if(!this.limitFlag){
                const param = {
                    groupUuid: this.groupUuid,
                    groups:this.paramGroup
                }
                let _this = this
                _this.$fetch({
                    url: _this.$baseUrl + 'ebook/class/common/saveClassRandomGroup',
                    body:param
                }).done(res => {
                    if(res && res.success && res.resultCode === 0){
                        _this.$message.success('保存小组成功')
                        _this.$router.push({name: 'AccompanyStudy'})
                    }else{
                        _this.$message.warning(res.resultMessage)
                    }
                })
            }else{
                this.$message.warning('小组名请控制在8个字以内')
            }
        },
        editGroupNameChange (item) {
            if(item.groupName.length>8){
                this.$message.warning('请您输入小组名称在8个汉字以内')
                return
            }
            const param = {
                groupId: item.id,
                groupName: item.groupName
            }
            let _this = this
            _this.$fetch({
                url: _this.$baseUrl + 'ebook/class/common/editClassGroup',
                body:param
            }).done( res => {
                if(res && res.success && res.resultCode === 0){
                    _this.$message.success('修改小组名称成功')
                    _this.editGroup = true
                }
            })
        },
        editGroupName (index,item) { //修改组名称
            this.editGroup = false
            this.$refs.input[index].focus()
        },
    getClassInfo () {
      // 获取班级详细信息
      // let _this = this
      // this.$fetch({
      //     url: _this.$baseUrl + 'ebook/group/common/getClassInfoById',
      //     body:{id:localStorage.getItem('classID')}
      // }).done(res =>{
      //     if(res && res.success && res.resultCode === 0){
      //     _this.stuNum = res.resultData.studentCount
      //     }
      // })
      // 根据班级id 获取班级学生列表
      const _this = this
      _this.$fetch({
        url: _this.$baseUrl + 'ebook/class/common/v2/getV2MyClassStu',
        body: { classId: localStorage.getItem('classID') }
      })
        .done((res) => {
          if (res && res.success && res.resultCode === 0) {
            const stu = res.resultData.filter((msg) => msg.isTea === 0)
            _this.stuNum = stu.length
            console.log('getV2MyClassStu')
            console.log(res)
          }
        })
    }
  }
}
</script>
